import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.riskLevels;
export const riskLevelsSelector = (state: RootState) => getState(state).data;
export const riskLevelsIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const riskLevelsIsReadySelector = (state: RootState) => getState(state).isReady;
export const riskLevelsErrorSelector = (state: RootState) => getState(state).error;
